import { render, staticRenderFns } from "./secondTv.vue?vue&type=template&id=34d8b2bc&scoped=true&"
import script from "./secondTv.vue?vue&type=script&lang=js&"
export * from "./secondTv.vue?vue&type=script&lang=js&"
import style0 from "./secondTv.vue?vue&type=style&index=0&id=34d8b2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8b2bc",
  null
  
)

export default component.exports